import { KeyValue } from "types/KeyValue";

export default function sortKeyValue(array: KeyValue[]): KeyValue[] {
  return array?.sort((a, b) => (a.value || "").toString().localeCompare((b.value || "").toString()))
}